// import moment from 'moment'
import * as ismobilejs from 'ismobilejs'
import { Capacitor } from '@capacitor/core'
import { Clipboard } from '@capacitor/clipboard'

// import i18n from '../i18n'

export const isMobile = ismobilejs.default(window.navigator)

// export function localizedDateString (date: string | Date) {
//   const created = moment(date)
//   const now = moment()
//   if (created.isSame(now, 'day')) {
//     return i18n.t('date.today') as string
//   } else if (created.isSame(now.subtract(1, 'day'), 'day')) {
//     return i18n.t('date.yesterday') as string
//   } else {
//     return created.format('LL')
//   }
// }

export async function presentMessage (component: Vue, header: string, message?: string) {
  const alert = await component.$ionic.alertController.create({
    header,
    message,
    buttons: ['OK'],
  })
  await alert.present()
}

export async function delay (milliseconds: number) {
  return new Promise((res) => setTimeout(res, milliseconds))
}

export function isIOS () {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'ios'
}

export function copyToClipboard (text: string) {
  if (Capacitor.isNativePlatform()) {
    Clipboard.write({
      string: text,
    })
  } else {
    const el = document.createElement('textarea')
    document.body.appendChild(el)
    el.value = text
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }
}

